import { lazy } from 'react';
import { DOCUMENTS_AUTH, READ_PERMISSION, CREATE_PERMISSION, UPDATE_PERMISSION } from 'src/constants/permissions';
import { PermissionsGuard } from 'src/routing/components';

export const Routes = [
    {
        exact: true,
        path: '/create/document',
        guard: PermissionsGuard,
        roles: {
            permission: DOCUMENTS_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/document/DocumentCreateView')),
    },
    {
        exact: true,
        path: '/management/documents/:id',
        guard: PermissionsGuard,
        roles: {
            permission: DOCUMENTS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/document/DocumentDetailsView')),
    },
    {
        exact: true,
        path: '/management/documents/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: DOCUMENTS_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(() => import('src/views/document/DocumentEditView')),
    },

    {
        exact: true,
        path: '/management/documents',
        guard: PermissionsGuard,
        roles: {
            permission: DOCUMENTS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/document/DocumentListView')),
    },
];
